import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export const TermAndCondition = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="home-main pt-0 pt-lg-0 pb-2">
      <section className="Breadcrumbs-section">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">
                <Link to="/terms-and-conditions">Terms And Conditions</Link>
              </li>
            </ol>
          </nav>
        </div>
      </section>
      <div className="container mb-5">
        <div className="terms-info-wrapper">
          <ul>
            <li className="terms-heading text-heading">Terms and conditions</li>
          </ul>
          <p>Welcome to bossdentindia.com!</p>
          <p>
            These terms and conditions outline the rules and regulations for the
            use of bossdentindia’s Website, located at{" "}
            <Link
              to="https://bossdentindia.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://bossdentindia.com
            </Link>
          </p>
          <p>
            By accessing this website we assume you accept these terms and
            conditions. Do not continue to use bossdentindia.com if you do not
            agree to take all of the terms and conditions stated on this page.
          </p>
          <p>
            Prices for our products are subject to change without prior
            notice.We reserve the right at any time to modify or discontinue the
            Service (or any part or content thereof) without notice at any
            time.We shall not be liable to you or to any third-party for any
            modification, price change, suspension or discontinuance of the
            Service.
          </p>
          <h3>Order Cancelletion Policy</h3>
          <p>
            At Boss Dent India, we strive to provide excellent service and
            quality products to our valued customers. We understand that
            sometimes circumstances may change, and you may need to cancel your
            order. Below is our order cancellation policy to help you understand
            our procedures and conditions for cancellations.
          </p>
          <h4>1. Cancellation Request</h4>
          <ul>
            <li>
              You may request to cancel your order within 24 hours of placing
              it. To do so, please contact our customer service team as soon as
              possible at zahndentaldepo@gmail.com or 76988 28883.
            </li>
          </ul>
          <h4>2. Conditions for Cancellation</h4>
          <ul>
            <li>
              Orders can only be canceled if they have not yet been processed or
              shipped. Once an order has been processed or shipped, it cannot be
              canceled.
            </li>
          </ul>
          <h4>3. Procedure for Cancellation</h4>
          <ul>
            <li>
              To cancel your order, please provide your order number, the name
              under which the order was placed, and a brief reason for the
              cancellation. Our customer service team will confirm the
              cancellation and process any applicable refunds.
            </li>
          </ul>
          <h4>4. Refunds</h4>
          <ul>
            <li>
              If your cancellation request is received and approved within the
              specified timeframe, a full refund will be issued to the original
              payment method used. Refunds may take 5-10 business days to appear
              in your account, depending on your bank or credit card issuer.
            </li>
          </ul>
          <h4>5. Exceptions</h4>
          <ul>
            <li>
              Customized or personalized items are non-refundable and cannot be
              canceled once production has begun. Sale items or items purchased
              during promotional events may have different cancellation terms.
              Please refer to the specific terms and conditions provided during
              the sale.
            </li>
          </ul>
          <h4>6. Contact Information</h4>
          <ul>
            <p style={{ marginLeft: "-38px" }}>
              For any questions or to request an order cancellation, please
              contact our customer service team at:
            </p>
            <li>Email: [zahndentaldepo@gmail.com]</li>
            <li>Phone: [76988 28883]</li>
            <li>
              Address: [Plot no.3-3/3-4/ Dhuna house, opp. Patel Nagar, A.k.
              Road, Varachha, Surat]
            </li>
          </ul>
          <h4>7. Changes to This Policy</h4>
          <ul>
            <li>
              Boss Dent India reserves the right to modify this cancellation
              policy at any time. Changes will be posted on our website, and the
              date of the latest update will be indicated at the top of the
              policy.
            </li>
            <li>
              Thank you for choosing Boss Dent India. We appreciate your
              understanding and cooperation regarding our order cancellation
              policy. If you have any questions or concerns, please do not
              hesitate to contact us.
            </li>
          </ul>
          <h3>Cookies</h3>
          <ul>
            <li>
              We employ the use of cookies. By accessing bossdentindia.com, you
              agreed to use cookies in agreement with the bossdentindia’s
              Privacy Policy.
            </li>
            <li>
              Most interactive websites use cookies to let us retrieve the
              user’s details for each visit. Cookies are used by our website to
              enable the functionality of certain areas to make it easier for
              people visiting our website. Some of our affiliate/advertising
              partners may also use cookies.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
